import React from "react";

const Cost = () => {
  return (
    <div className="bg-[#39699D]">
      <div className="max-w-6xl mx-auto md:p-10 p-3 space-y-5">
        <div>
          <p className="text-white font-bold">Program Cost</p>
        </div>
        <div className="bg-sdbodywhite h-0.5 w-10 my-2"></div>
        <div className="text-sm md:text-base">
          <div>
            <div className="p-2 bg-[#498ED8] border-l-2 border-black inline-block text-white">
              <p>Flexible and Customised Pricing</p>
            </div>
            <div>
              <p className="text-white my-5">
                The cost of participating in our Executive Education Programmes
                is determined on a case-by-case basis to accommodate the unique
                needs of participants, sponsoring organisations, and
                governments. This approach ensures that the pricing aligns with
                the programmes delivery mode, duration, and any additional
                customisation.
              </p>
            </div>
          </div>
          <div>
            <div className="p-2 bg-[#634902] text-white inline-block">
              <p>Cost Details</p>
            </div>
            <div className="p-2 rounded-tl-md border-2 border-white my-5">
              <div className="p-2 bg-[#B8DAFF] rounded-tl-md inline-block">
                <p>Cost Per Participant: Ranges from €2,500 to €4,000.</p>
              </div>
              <div className="text-white ">
                <p className="my-3">The final cost will take into account:</p>
                <div className="flex items-center space-x-2 mb-2">
                  <div>
                    <img
                      src="/image-fix/icon-collections/education-flat-line-icon-collection/check-circle-svgrepo-com.svg"
                      className="h-5 w-5"
                    />
                  </div>
                  <div>
                    <p>
                      The number of participants from each organisation or
                      country.
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-2 mb-2">
                  <div>
                    <img
                      src="/image-fix/icon-collections/education-flat-line-icon-collection/check-circle-svgrepo-com.svg"
                      className="h-5 w-5"
                    />
                  </div>
                  <div>
                    <p>The selected programme and delivery format.</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2 mb-2">
                  <div>
                    <img
                      src="/image-fix/icon-collections/education-flat-line-icon-collection/check-circle-svgrepo-com.svg"
                      className="h-5 w-5"
                    />
                  </div>
                  <div>
                    <p>
                      Any additional features such as study tours or customised
                      sessions.
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="p-2 bg-[#B8DAFF] rounded-tl-md inline-block mt-5 mb-3">
                  <p>Exclusion</p>
                </div>
                <div className="text-white">
                  <div className="flex items-center space-x-2 mb-2">
                    <div>
                      <img
                        src="/image-fix/icon-collections/education-flat-line-icon-collection/check-circle-svgrepo-com.svg"
                        className="h-5 w-5"
                      />
                    </div>
                    <div>
                      <p>
                        The cost does not include accommodation, visa
                        processing, or travel expenses.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 mb-2">
                    <div>
                      <img
                        src="/image-fix/icon-collections/education-flat-line-icon-collection/check-circle-svgrepo-com.svg"
                        className="h-5 w-5"
                      />
                    </div>
                    <div>
                      <p>
                        Participants or their sponsoring organisations are
                        responsible for arranging these services.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="p-2 bg-[#634902] text-white inline-block">
              <p>What’s Included in the Cost?</p>
            </div>
            <div>
              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black mt-3 mb-2">
                <p>
                  Comprehensive Learning Materials: Access to all course
                  materials, reading lists, and practical tools.
                </p>
              </div>

              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Expert-Led Workshops and Lectures: Delivered by renowned
                  leaders in governance, diplomacy, and international relations.
                </p>
              </div>

              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Simulations and Case Studies: Hands-on experience in
                  real-world scenarios.
                </p>
              </div>

              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Group Forums and Networking Opportunities: Build connections
                  with peers and experts from across the globe.
                </p>
              </div>

              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Educational Visits (where applicable): Gain insights from
                  relevant institutions and governance hubs.
                </p>
              </div>

              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Programme Certification: Earn a prestigious certificate of
                  completion for professional advancement.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <div className="p-2 bg-[#634902] text-white inline-block">
              <p>Payment and Sponsorship</p>
            </div>
            <div>
              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black mt-3 mb-2">
                <p>
                  Payments can be made by individuals or sponsoring
                  organisations.
                </p>
              </div>
              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Discounts may apply for organisations enrolling multiple
                  participants or for country-level partnerships.
                </p>
              </div>
              <div className="bg-[#B8DAFF] p-2 text-black border-l-2 border-black my-2">
                <p>
                  Customized group packages are available for large-scale
                  enrollment.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-white text-sm md:text-base">
          <p>
            For more information on pricing and customisation options, please
            contact our Executive Education Development Team at
            <span className="pl-2 text-[#EBCECE]">
              ee@sapphirediplomacy.com
            </span>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Cost;
